import {
    bikePassengerCode,
    carPassengerCode, largeCarPassengerCode,
    motorcyclePassengerCode
} from "@CheckOrder/features/addons/features/jadrolinija/constants/vehiclePassengerCodes";
import {VehicleAddonResponseType} from "@CheckOrder/api/types/GetAddonDataQuery.type";

export default function checkActiveOptionType() {
    const isBike = (activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType }) => (
        activeOption.value === bikePassengerCode
    )
    const isMotorcycle = (activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType }) => (
        activeOption.value === motorcyclePassengerCode
    )
    const isCar = (activeOption: { value: number, label: string, activeGroup: VehicleAddonResponseType }) => (
        activeOption.value === carPassengerCode || activeOption.value === largeCarPassengerCode
    )

    return {
        isBike,
        isMotorcycle,
        isCar,
    }
}